window.FinderAnsicht = function (k) {
  'use strict';

  var $ = k.$,
      $$ = k.$$,
      BUNDLE_AMOUNT = k.BUNDLE_AMOUNT,
      BUNDLE_TITEL = k.BUNDLE_TITEL || '',
      MAX_MON = k.MAX_MON,
      SEARCH_SVG = k.SEARCH_SVG,
      T = k.T,
      _bundleUnits = k._bundleUnits,
      _bundleUnitsPotential = k._bundleUnitsPotential,
      _metaPlain = k._metaPlain,
      _mediaUrl = k._mediaUrl,
      S = k.S,
      _price = k._price,
      _reqCovered = k._reqCovered,
      _reqIncluded = k._reqIncluded,
      _requiredTierAllDone = k._requiredTierAllDone,
      _vesaAnswerSummary = k._vesaAnswerSummary,
      _waLinkWithSetup = k._waLinkWithSetup,
      bundleDiscountCents = k.bundleDiscountCents,
      bundleBisZuCents = k.bundleBisZuCents || function(){ return 0; },
      d = k.d,
      disable = k.disable,
      esc = k.esc,
      filledMonitors = k.filledMonitors,
      monitorVesaUnknown = k.monitorVesaUnknown,
      restartBtn = k.restartBtn,
      root = k.root,
      selectPreset = k.selectPreset,
      setText = k.setText,
      slotsWrap = k.slotsWrap,
      sonderloesungMonitore = k.sonderloesungMonitore,
      state = k.state,
      summaryItems = k.summaryItems,
      vesaCompleteFor = k.vesaCompleteFor,
      vesaFor = k.vesaFor,
      vesaHasPattern = k.vesaHasPattern,
      vesaModalSeen = k.vesaModalSeen,
      vesaOpenSlots = k.vesaOpenSlots,
      vesaOverlay = k.vesaOverlay,
      vesaRefs = k.vesaRefs,
      vesaSlot = k.vesaSlot,
      vesaTpl = k.vesaTpl;

  var addBtn = null;

  function _wurzel(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  var regelTexte = [];

  var miniVorrat = {};

  function miniBedienen(leib, vorteilCent, einheiten){
    var daten = null;
    var quelle = leib.querySelector('script[data-mpd-daten]');
    if(quelle){ try { daten = JSON.parse(quelle.textContent); } catch(e){ daten = null; } }

    var spur = leib.querySelector('[data-mpd-spur]');
    if(spur){
      var punkte = leib.querySelectorAll('[data-mpd-punkt]');
      var zeigen = function(i){
        var bilder = spur.children;
        if(!bilder.length) return;
        var n = Math.max(0, Math.min(i, bilder.length - 1));
        spur.scrollTo({ left: bilder[n].offsetLeft - spur.offsetLeft, behavior: 'smooth' });
      };
      var aktuell = function(){ return Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth)); };
      var vor = leib.querySelector('[data-mpd-vor]'), zur = leib.querySelector('[data-mpd-zur]');
      if(vor) vor.addEventListener('click', function(){ zeigen(aktuell() - 1); });
      if(zur) zur.addEventListener('click', function(){ zeigen(aktuell() + 1); });
      var markieren = function(){
        var n = aktuell();
        punkte.forEach(function(pk, i){ pk.setAttribute('aria-current', i === n ? 'true' : 'false'); });
      };
      punkte.forEach(function(pk){
        pk.addEventListener('click', function(){ zeigen(Number(pk.getAttribute('data-mpd-punkt'))); });
      });
      spur.addEventListener('scroll', markieren);
      markieren();
    }

    var feldId = leib.querySelector('[data-mpd-variante]');
    var kaufKnopf = leib.querySelector('[ref="addToCartButton"]');
    var mpd = leib.querySelector('.mpd') || leib;
    var kaufLabel = mpd.getAttribute('data-mpd-text-kauf') || '';
    var ausLabel = mpd.getAttribute('data-mpd-text-aus') || '';
    var preisEl = leib.querySelector('[data-mpd-preis]');
    var auswahlen = leib.querySelectorAll('[data-mpd-option]');

    function preisSetzen(v){
      if(!preisEl) return;
      var klein = preisEl.querySelector('small');
      var schwanz = klein ? ' ' + klein.outerHTML : '';
      var betrag = (v && v.betrag != null) ? v.betrag : null;
      if(vorteilCent > 0 && betrag != null && vorteilCent < betrag){

        preisEl.innerHTML = '<s class="fn-price-was">' + _price(betrag) + '</s>'
          + '<span class="fn-price-now">' + _price(betrag - vorteilCent) + '</span>'
          + schwanz
          + '<span class="mpd__preis-vorteil">' + _vorteilEtikett(einheiten, false) + '</span>';
      } else if(v && v.preis){
        preisEl.innerHTML = v.preis + schwanz;
      }
    }

    function passendeVariante(){
      if(!daten || !daten.varianten) return null;
      var gewaehlt = [];
      auswahlen.forEach(function(sel){ gewaehlt[Number(sel.getAttribute('data-mpd-option'))] = sel.value; });
      if(!gewaehlt.length) return daten.varianten[0];
      for(var i = 0; i < daten.varianten.length; i++){
        var v = daten.varianten[i], passt = true;
        for(var q = 0; q < gewaehlt.length; q++){
          if(gewaehlt[q] && v.optionen[q] !== gewaehlt[q]){ passt = false; break; }
        }
        if(passt) return v;
      }
      return null;
    }

    function nachziehen(){
      var v = passendeVariante();
      if(!v) return;
      if(feldId) feldId.value = v.id;
      preisSetzen(v);
      if(kaufKnopf){
        kaufKnopf.disabled = !v.kaufbar;
        var beschriftung = kaufKnopf.querySelector('.add-to-cart-text__content span span');
        if(beschriftung) beschriftung.textContent = v.kaufbar ? kaufLabel : ausLabel;
      }
    }
    auswahlen.forEach(function(sel){ sel.addEventListener('change', nachziehen); });
    nachziehen();
  }

  function miniPdpOeffnen(handle, vorteilCent, einheiten){
    var dlg = $('[data-role="mini-dialog"]'), leib = $('[data-role="mini-leib"]');
    if(!handle) return;

    if(!dlg || !leib || !dlg.showModal){ window.location.href = _wurzel() + 'products/' + handle; return; }

    if(!dlg.__gebunden){
      dlg.__gebunden = true;
      dlg.addEventListener('click', function(e){
        if(e.target === dlg){ dlg.close(); return; }
        if(e.target.closest && e.target.closest('[data-mpd-zu]')) dlg.close();
      });

      document.addEventListener('shopify:cart:lines-update', function(e){
        if(!dlg.open) return;
        var zu = function(){ setTimeout(function(){ if(dlg.open) dlg.close(); }, 400); };
        var fertig = e && e.promise;
        if(fertig && fertig.then) fertig.then(zu, zu); else zu();
      });
    }
    leib.innerHTML = '<p class="fn-mini-laedt">' + esc(T.laedt) + '</p>';
    dlg.showModal();
    if(!miniVorrat[handle]){
      miniVorrat[handle] = fetch(_wurzel() + 'products/' + handle + '?section_id=mini-produktseite')
        .then(function(r){ return r.text(); });
    }
    miniVorrat[handle].then(function(html){
      if(!dlg.open) return;
      leib.innerHTML = html;
      miniBedienen(leib, vorteilCent || 0, einheiten || 0);
    }).catch(function(){
      leib.innerHTML = '<p class="fn-mini-laedt">' + esc(T.ladenFehler) + '</p>';
    });
  }

  function _vorteilEtikett(einheiten, erfuellt){
    if(!(BUNDLE_AMOUNT > 0) || !(einheiten > 0)) return '';
    var wort = erfuellt ? ''
      : (einheiten === 1 ? (T.withAdapter || '')
                         : String(T.withAdapters || '').replace('%d', einheiten));
    return '<span class="vorteil-etikett">\u2212' + (einheiten * BUNDLE_AMOUNT) + '\u00a0\u20ac'
      + (wort ? ' ' + esc(String(wort).trim()) : '') + '</span>';
  }

  function _teilName(titel, namen){
    var kurz = String(titel || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
    if(!namen || !namen.length) return kurz;
    var muster = String(T.teilFuer || '@TEIL@ @GERAETE@');

    var trenner = muster.split('@TEIL@').pop().split('@GERAETE@')[0];

    var mDe = kurz.match(/^(.*?)\s+für\s+/i);
    if(mDe) kurz = mDe[1];
    else {
      var pos = trenner.trim() ? kurz.toLowerCase().indexOf(trenner.toLowerCase()) : -1;
      if(pos > 0) kurz = kurz.slice(0, pos);
    }
    return muster.replace('@TEIL@', kurz.trim()).replace('@GERAETE@', namen.join(', '));
  }

  function _zeilenGeraete(x){
    var namen = [], gesehen = {};
    (x.slots || []).forEach(function(si){
      var m = state.slots[si] && state.slots[si].monitor;
      if(!m || !m.name || gesehen[m.ref]) return;
      gesehen[m.ref] = true; namen.push(m.name);
    });
    return namen;
  }

  function _satzTeil(x){
    var roh = (x.product && x.product.name) || (x.sp && x.sp.title) || '';
    var kurz = String(roh).split('|')[0].replace(/\s+/g, ' ').trim();
    return _teilNameFuer((x.product && x.product.type) || '', kurz, _zeilenGeraete(x));
  }

  function _teilNameFuer(art, titel, namen){
    return (art === 'ADAPTER') ? _teilName(titel, namen) : String(titel || '');
  }

  function regelFensterBinden(knopf){
    knopf.addEventListener('click', function(){
      var e = regelTexte[+knopf.getAttribute('data-regel')];
      if(!e) return;
      var text  = document.querySelector('[data-role="regel-text"]');

      if(text) text.innerHTML = e.text || '';
    });
  }

  function _vesaStatisch(m){
    var v = m.vesa;
    if(monitorVesaUnknown(m)){
      var sum = _vesaAnswerSummary(m.ref);
      return sum ? '<span class="fn-vesa-chip is-static"><span>' + esc(sum) + '</span></span>' : '';
    }
    if(!v) return '';
    if(v.mount === 'NO') return '<span class="fn-vesa-chip is-static is-none"><span>' + esc(T.novesaLabel) + '</span></span>';
    if(v.patterns && v.patterns.length) return '<span class="fn-vesa-chip is-static is-ok"><span>' + esc('VESA ' + v.patterns[0]) + '</span></span>';
    return '';
  }

  function _vesaChip(m, slotIdx){
    if(monitorVesaUnknown(m)){
      var sum = _vesaAnswerSummary(m.ref);

      var tone = !sum ? ' is-todo' : ((state.vesaBy[m.ref]||{}).pattern === 'none' ? ' is-none' : '');

      return '<button type="button" class="fn-vesa-chip'+tone+'" data-act="vesa-toggle" data-slot="'+slotIdx+'" aria-expanded="false">'
        + '<span>'+esc(sum || T.vesaNeeded)+'</span>'
        + '<svg class="fn-vesa-chip-arr" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
        + '</button>';
    }

    var v = m.vesa;
    if(!v) return '';

    if(v.mount === 'NO') return '<span class="fn-vesa-chip is-static is-none"><span>'+esc(T.novesaLabel)+'</span></span>';
    if(v.patterns && v.patterns.length) return '<span class="fn-vesa-chip is-static is-ok"><span>'+esc('VESA ' + v.patterns[0])+'</span></span>';
    return '';
  }

  var SYM_MON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M9 20h6M12 16v4"/></svg>';
  var SYM_DUP = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';

  var SYM_SW  = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h12l-3-3M20 15H8l3 3"/></svg>';
  var SYM_RM  = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6"/><path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';

  function renderSlots(){
    slotsWrap.innerHTML = state.slots.map(function(slot, i){

      if(slot.monitor && !slot.__bearb){
        var m = slot.monitor;
        var bild = m.image_url
          ? '<img src="' + esc(_mediaUrl(m.image_url)) + '" alt="">'
          : SYM_MON;
        var tat = '<span class="fn-zeile-tat">'
          + (state.slots.length < MAX_MON
              ? '<button type="button" class="fn-tat" data-act="dup" data-slot="'+i+'" aria-label="'+esc(T.duplicate)+'" title="'+esc(T.duplicate)+'">'+SYM_DUP+'</button>'
              : '')
          + (state.slots.length > 1
              ? '<button type="button" class="fn-tat" data-act="rm" data-slot="'+i+'" aria-label="'+esc(T.remove)+'" title="'+esc(T.remove)+'">'+SYM_RM+'</button>'
              : '<button type="button" class="fn-tat" data-act="sw" data-slot="'+i+'" aria-label="'+esc(T.slotErsetzen)+'" title="'+esc(T.slotErsetzen)+'">'+SYM_SW+'</button>')
          + '</span>';
        return '<div class="fn-slot" data-slot="'+i+'">'
          + '<div class="fn-zeile">'
          + '<span class="fn-zeile-sym">'+bild+'</span>'
          + '<span class="fn-zeile-txt"><span class="fn-zeile-name">'+esc(m.name)+'</span>'
          + '<span class="fn-zeile-daten">'+esc(m.specs||'')+'</span></span>'
          + _vesaChip(slot.monitor, i) + tat + '</div></div>';
      }

      var abbruch = slot.__bearb
        ? '<button type="button" class="fn-slot-ab" data-act="cancel" data-slot="'+i+'">'+esc(T.slotAbbrechen)+'</button>'
        : '';
      return '<div class="fn-slot'+(slot.__bearb ? ' is-bearb' : '')+'" data-slot="'+i+'">'
        + '<div class="fn-slot-inpwrap">'+SEARCH_SVG
        + '<input type="text" class="fn-inp fn-slot-inp" data-slot="'+i+'" autocomplete="off">'+abbruch+'</div>'
        + '<div class="fn-dd fn-slot-dd" data-slot="'+i+'" style="display:none"></div></div>';
    }).join('');

    slotsWrap.querySelectorAll('.fn-slot-inp').forEach(function(inp){ inp.placeholder = T.placeholder; });

    if(window.Suchebene){
      slotsWrap.querySelectorAll('.fn-slot').forEach(function(slotEl){
        var inp = slotEl.querySelector('.fn-slot-inp');
        var dd = slotEl.querySelector('.fn-slot-dd');
        var leiste = slotEl.querySelector('.fn-slot-inpwrap');
        if(!inp || !dd || !leiste) return;
        window.Suchebene.binden({
          leiste: leiste,
          eingabe: inp,
          liste: dd,

          zu: function(){
            dd.style.display = 'none'; dd.innerHTML = '';

            var ab = slotEl.querySelector('.fn-slot-ab');
            if(ab) setTimeout(function(){ if(ab.isConnected) ab.click(); }, 0);
          },
          titel: (filledMonitors().length === 1 ? T.monitorTitel : T.monitoreTitel)
        });
      });
    }

    slotsWrap.querySelectorAll('.fn-zeile-sym img').forEach(function(im){
      im.onerror = function(){ this.style.visibility = 'hidden'; };
    });

    var seenRef = {};
    state.slots.forEach(function(slot, i){
      if(!slot.monitor || !monitorVesaUnknown(slot.monitor)) return;
      if(seenRef[slot.monitor.ref]) return;
      seenRef[slot.monitor.ref] = true;
      var slotEl = slotsWrap.querySelector('.fn-slot[data-slot="'+i+'"]'); if(!slotEl) return;
      var box = buildVesaBox(slot.monitor.ref); if(!box) return;
      slotEl.classList.add('has-vesa');

      var done = vesaCompleteFor(slot.monitor.ref);
      slotEl.classList.toggle('is-vesa-open', !done || !!vesaOpenSlots[slot.monitor.ref]);
      slotEl.appendChild(box);
    });
    syncVesaUI();
    bloeckeSetzen();
    var addBtn = $('#fn-addmon');
    var voll = state.slots.length >= MAX_MON;
    if(addBtn){
      addBtn.style.display = (filledMonitors().length > 0 || state.slots.length > 1) ? 'block' : 'none';
      addBtn.disabled = voll;
    }

    var grenze = $('[data-role="grenze"]');
    if(grenze) grenze.hidden = !voll;
  }

  function syncVesaUI(){
    document.querySelectorAll('.fn-vesa[data-vesa-ref]').forEach(function(box){
      var v = vesaFor(box.getAttribute('data-vesa-ref'));
      ['pattern','recessed','shape'].forEach(function(k){
        var grp = box.querySelector('[data-fn-vesa="'+k+'"]'); if(!grp) return;
        grp.querySelectorAll('.fn-choice').forEach(function(b){
          b.classList.toggle('is-sel', b.getAttribute('data-value') === v[k]);
        });
      });

      var otherSel = box.querySelector('[data-role="vesa-other"]');
      if(otherSel){
        otherSel.style.display = (v.pattern === 'other') ? '' : 'none';
        otherSel.value = v.otherPattern || '';
      }
      var holes = box.querySelector('[data-role="vesa-holes"]');
      if(holes) holes.style.display = vesaHasPattern(v) ? '' : 'none';
      var shapeQ = box.querySelector('[data-role="vesa-shape"]');
      if(shapeQ) shapeQ.style.display = (v.recessed === 'yes') ? '' : 'none';
    });
  }
  function buildVesaBox(ref){
    if(!vesaTpl) return null;
    var box = vesaTpl.content.firstElementChild.cloneNode(true);
    box.setAttribute('data-vesa-ref', ref);
    return box;
  }
  function openVesaModal(){
    if(!vesaOverlay || !vesaSlot) return;
    if(vesaOverlay.style.display !== 'none') return;

    var ref = vesaRefs().filter(function(r){ return !vesaCompleteFor(r) && !vesaModalSeen[r]; })[0];
    if(!ref) return;
    var box = buildVesaBox(ref); if(!box) return;
    vesaModalSeen[ref] = true;
    vesaSlot.innerHTML = '';
    vesaSlot.appendChild(box);
    var mo = filledMonitors().filter(function(m){ return String(m.ref) === String(ref); })[0];
    var nameEl = $('[data-role="vesa-modal-monitor"]');
    if(nameEl) nameEl.textContent = mo ? mo.name : '';
    vesaOverlay.style.display = '';
    document.body.style.overflow = 'hidden';
    syncVesaUI();
  }
  function closeVesaModal(){
    if(!vesaOverlay || vesaOverlay.style.display === 'none') return;
    vesaOverlay.style.display = 'none';
    document.body.style.overflow = '';
    if(vesaSlot) vesaSlot.innerHTML = '';
  }

  function showVesaGate(){

    state.presets=[]; state.required=[]; state.optional=[]; state.optionalRules=[]; state.optionalFunnel=[];
    state.selPreset=null;
    var req = $('[data-role="required"]'); if(req) req.style.display='none';
    var oneHead = $('[data-role="one-head"]'); if(oneHead) oneHead.style.display='none';
    var oneSec = $('[data-role="one-section"]'); if(oneSec) oneSec.style.display='none';
    var mountWrap = $('[data-role="mount-groups"]'); if(mountWrap) mountWrap.innerHTML='';
    var empty = $('[data-role="halterung-empty"]'); if(empty) empty.style.display='none';
    var opt = $('[data-role="optional"]'); if(opt) opt.style.display='none';
    var grid = $('[data-role="presets"]'); if(grid) grid.innerHTML='';
    var moreWrap = $('[data-role="more"]'); if(moreWrap){ moreWrap.style.display='none'; moreWrap.innerHTML=''; }
    root.__redrawPresets = null;
    setSummaryEmpty();
    var oneWrap = $('[data-role="one-wrap"]'); if(oneWrap) oneWrap.style.display='none';

    openVesaModal();
  }

  function updateActiveState(){
    var on = filledMonitors().length > 0;
    var mbar=$('#fn-mobilebar');
    if(mbar) mbar.style.display = on ? 'block' : 'none';

    var oneWrap = $('[data-role="one-wrap"]');
    if(oneWrap) oneWrap.style.display = on ? '' : 'none';

    if(restartBtn) restartBtn.style.display = on ? '' : 'none';
    document.body.classList.toggle('fn-hasbar', on);
    document.body.classList.toggle('fn-active', on);

    var sek = root.closest ? root.closest('.fn-section') : null;
    if(sek && sek.getAttribute('data-fn-verbergen') === 'ja'){
      sek.classList.toggle('fn-section--verborgen', !on);
    }
  }

  function showHalterungFallback(gestoert){
    var req = $('[data-role="required"]'); if(req) req.style.display='none';
    var oneSec = $('[data-role="one-section"]'); if(oneSec) oneSec.style.display='none';
    var oneHead = $('[data-role="one-head"]'); if(oneHead) oneHead.style.display='none';
    var mountWrap = $('[data-role="mount-groups"]'); if(mountWrap) mountWrap.innerHTML='';
    var opt = $('[data-role="optional"]'); if(opt) opt.style.display='none';
    root.__redrawPresets = null;
    setSummaryEmpty();
    var oneWrap = $('[data-role="one-wrap"]'); if(oneWrap) oneWrap.style.display='';
    var emptyBox = $('[data-role="halterung-empty"]'); if(emptyBox) emptyBox.style.display='';

    var leerTxt = $('[data-role="halterung-empty-text"]');
    var stoerTxt = $('[data-role="halterung-stoerung"]');
    var sonderTxt = $('[data-role="halterung-sonder"]');

    var sonder = !gestoert && _allesOffen();
    if(leerTxt) leerTxt.style.display = (gestoert || sonder) ? 'none' : '';
    if(stoerTxt) stoerTxt.style.display = gestoert ? '' : 'none';
    if(sonderTxt) sonderTxt.style.display = sonder ? '' : 'none';

    var waLink = $('.fn-required-info-wa');
    if(waLink) waLink.style.display = sonder ? 'none' : '';

    var kasten = $('[data-role="halterung-empty"]');
    if(kasten) kasten.classList.toggle('is-sonder', sonder);

    var block = $('[data-role="one-wrap"]');
    if(block) block.classList.toggle('is-sonder', sonder);
  }

  function _fuellen(vorlage, werte){
    if(!vorlage) return '';
    return vorlage.replace(/%\{(\w+)\}/g, function(_, name){
      var v = werte[name];
      return v == null ? '' : '<b>' + esc(String(v)) + '</b>';
    });
  }

  var blockStand = { monitore: { zu:false, einmal:false, vomNutzer:false },
                     auswahl:  { zu:false, einmal:false, vomNutzer:false } };
  var blockGebunden = false;

  function _blockEl(name){
    return name === 'monitore' ? $('[data-role="block-monitore"]') : $('[data-role="one-wrap"]');
  }

  function _wahlzeilen(){
    var mons = filledMonitors();
    if(!mons.length) return '';
    var zaehler = {}, reihe = [];
    mons.forEach(function(m){
      if(zaehler[m.ref] == null){ zaehler[m.ref] = 0; reihe.push(m); }
      zaehler[m.ref]++;
    });
    return reihe.map(function(m){
      var n = zaehler[m.ref];
      var bild = m.image_url
        ? '<img src="' + esc(_mediaUrl(m.image_url)) + '" alt="" loading="lazy">'
        : SYM_MON;
      return '<div class="fn-wahlzeile">'
        + '<span class="fn-wahlzeile-bild">' + bild + '</span>'
        + '<span class="fn-wahlzeile-txt">'
        + '<span class="fn-wahlzeile-n">' + (n > 1 ? n + '\u00d7 ' : '') + esc(m.name) + '</span>'
        + '<span class="fn-wahlzeile-d">' + esc(m.specs || '') + '</span>'
        + '</span>'

        + _vesaStatisch(m)
        + '</div>';
    }).join('');
  }

  function _blockAntwort(name){
    if(name === 'monitore'){
      return filledMonitors().length ? ' ' : '';
    }
    var p = state.selPreset != null ? state.presets[state.selPreset] : null;
    if(!p || !p.sp) return '';

    return p.sp.title + (p.sp.price != null ? ' · ' + _price(p.sp.price) : '');
  }

  function _kopfhoehe(){
    var h = 0;
    document.querySelectorAll('header, .header-wrapper, [data-header]').forEach(function(el){
      var st = window.getComputedStyle(el);
      if(st.position !== 'sticky' && st.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if(r.top <= 1 && r.height > h) h = r.height;
    });
    return h;
  }

  var merkBeobachter = null;
  function aufmerken(el){
    if(!el) return;
    function spielen(){
      el.classList.remove('fn-aufmerk');
      void el.offsetWidth;
      el.classList.add('fn-aufmerk');
      setTimeout(function(){ el.classList.remove('fn-aufmerk'); }, 2200);
    }
    if(merkBeobachter){ merkBeobachter.disconnect(); merkBeobachter = null; }
    if(!window.IntersectionObserver){ spielen(); return; }
    merkBeobachter = new IntersectionObserver(function(eintraege, beob){
      eintraege.forEach(function(e){
        if(!e.isIntersecting) return;
        beob.disconnect(); merkBeobachter = null; spielen();
      });
    }, { threshold: 0.35 });
    merkBeobachter.observe(el);
  }

  function hinlenken(el){
    if(!el || el.offsetParent === null) return;
    aufmerken(el);
    var r = el.getBoundingClientRect();
    var oben = _kopfhoehe() + 16, unten = window.innerHeight - 16;
    if(r.top >= oben && r.bottom <= unten) return;
    var platz = unten - oben;
    var ziel = (r.height <= platz)
      ? window.scrollY + r.top - oben - (platz - r.height) / 2
      : window.scrollY + r.top - oben;
    window.scrollTo({ top: Math.max(0, Math.round(ziel)), behavior: 'smooth' });
  }

  function bloeckeSetzen(){
    if(!blockGebunden){
      blockGebunden = true;
      $$('.fn-block-knopf[data-block]').forEach(function(b){
        b.addEventListener('click', function(){
          var name = b.getAttribute('data-block');
          var st = blockStand[name];
          if(!st) return;
          if(st.zu){ st.zu = false; st.vomNutzer = true; }
          else     { st.zu = true; }
          bloeckeSetzen();
          if(!st.zu){
            var el = _blockEl(name);
            if(el) el.scrollIntoView({ behavior:'smooth', block:'nearest' });
          }
        });
      });
    }

    var mt = $('[data-role="monitore-titel"]');
    if(mt) mt.textContent = (filledMonitors().length === 1) ? T.monitorTitel : T.monitoreTitel;

    var geradeFertig = null;
    ['monitore', 'auswahl'].forEach(function(name){
      var el = _blockEl(name);
      if(!el) return;
      var st = blockStand[name];
      var antwort = _blockAntwort(name);
      var beantwortet = !!antwort;

      var markiert = name === 'auswahl' && (/[?&](tp|tk|tz)=/.test(location.search) || !!document.querySelector('.fn-team [data-tipp]'));
      if(beantwortet && !st.einmal && !st.vomNutzer && !markiert){ st.einmal = true; st.zu = true; geradeFertig = name; }
      if(!beantwortet){ st.zu = false; }

      el.classList.toggle('fn-block--zu', st.zu);
      var ziel = el.querySelector('[data-role="antwort-' + name + '"]');
      if(ziel){
        if(name === 'monitore'){
          ziel.hidden = !st.zu;
          ziel.innerHTML = st.zu ? _wahlzeilen() : '';
        } else {
          ziel.textContent = st.zu ? antwort : '';
        }
      }
      var knopf = el.querySelector('.fn-block-knopf[data-block="' + name + '"]');
      if(knopf){
        knopf.hidden = !beantwortet;
        knopf.textContent = st.zu ? (knopf.getAttribute('data-wort-auf') || '\u00c4ndern')
                                  : (knopf.getAttribute('data-wort-zu')  || 'Fertig');
      }
    });

    if(geradeFertig){
      var weiter = geradeFertig === 'monitore' ? $('[data-role="one-wrap"]') : $('[data-role="summary"]');
      setTimeout(function(){ hinlenken(weiter); }, 80);
    }
  }

  function satzBauen(){
    var ziele = $$('[data-role="satz-text"]');
    if(!ziele.length) return;
    var mons = filledMonitors();
    if(!mons.length){ satzDa = false; satzZeigen(); return; }

    var namen = {}; mons.forEach(function(m){ namen[m.ref] = m.name; });
    var arten = Object.keys(namen);

    if(_allesOffen()){
      var sVorlage = mons.length === 1 ? S.sonderEins : S.sonderMehrere;
      var sonderSatz = _fuellen(sVorlage, { geraet: namen[arten[0]], anzahl: mons.length });
      ziele.forEach(function(z){ z.innerHTML = sonderSatz; });
      satzDa = !!sonderSatz;
      satzZeigen();
      return;
    }
    var wieviele = state.presets ? state.presets.length : 0;
    var teil = wieviele === 0 ? 'Keine' : (wieviele === 1 ? 'Eine' : 'Viele');
    var art = mons.length === 1 ? 'eins' : (arten.length === 1 ? 'gleiche' : 'verschiedene');
    var satz1 = _fuellen(S[art + teil], { geraet: namen[arten[0]], anzahl: mons.length, zahl: wieviele });

    var betroffen = {};
    state.required.forEach(function(x){
      if(x.requirement !== 'REQUIRED') return;
      if(!x.product || x.product.type !== 'ADAPTER') return;
      (x.slots || []).forEach(function(si){
        var m = state.slots[si] && state.slots[si].monitor;
        if(m) betroffen[m.ref] = m.name;
      });
    });
    var refs = Object.keys(betroffen);
    var satz2 = '';
    if(refs.length){
      var alle = refs.length >= arten.length;
      if(mons.length === 1)            satz2 = _fuellen(S.adapterEiner,  { geraet: betroffen[refs[0]] });
      else if(alle && mons.length === 2) satz2 = _fuellen(S.adapterBeide, {});
      else if(alle)                    satz2 = _fuellen(S.adapterAlle,   { anzahl: mons.length });
      else if(refs.length === 1)       satz2 = _fuellen(S.adapterNur,    { geraet: betroffen[refs[0]] });
      else                             satz2 = _fuellen(S.adapterEinige, { anzahl: refs.length });
    }

    var platte = state.required.some(function(x){
      return x.fromFunnel && x.requirement === 'REQUIRED' && !x.istVesaPlatte
             && !(x.product && x.product.type === 'ADAPTER');
    });
    var satz3 = platte ? _fuellen(S.plattePflicht, {}) : '';

    var genannt = {};
    state.required.forEach(function(x){
      if(x.requirement !== 'REQUIRED') return;
      if(x.product && x.product.type === 'ADAPTER') genannt[x.sku] = true;
      if(x.fromFunnel && !x.istVesaPlatte && !(x.product && x.product.type === 'ADAPTER')) genannt[x.sku] = true;
    });
    var noetig = [], geraten = [];
    state.required.forEach(function(x){
      if(!x.sp || genannt[x.sku]) return;
      if(x.requirement === 'REQUIRED') noetig.push(_satzTeil(x));
      else if(x.requirement === 'RECOMMENDED') geraten.push(_satzTeil(x));
    });
    var satz4 = noetig.length   ? _fuellen(S.noetig,   { teile: noetig.join(', ') })   : '';
    var satz5 = geraten.length  ? _fuellen(S.empfohlen,{ teile: geraten.join(', ') })  : '';

    var zweit = [satz2, satz3, satz4, satz5].filter(Boolean).join(' ');
    var text = satz1 + (zweit ? '<span class="fn-satz-zweit">' + zweit + '</span>' : '');
    ziele.forEach(function(z){ z.innerHTML = text; });
    satzDa = !!satz1;
    satzZeigen();
  }

  var satzDa = false;

  function satzZeigen(){
    var oben = $('[data-role="satz"]');
    if(oben) oben.hidden = !satzDa;

    var zeichen = $('.fn-satz-zeichen');
    if(zeichen) zeichen.style.display = _allesOffen() ? 'none' : '';
  }

  function renderRequired(){
    var ziel = $('[data-role="required-body"]');
    if(!ziel) return;

    var oben = $('[data-role="zubehoer-oben"]');
    if(oben) oben.hidden = !state.required.length;
    if(!state.required.length){ ziel.innerHTML = ''; return; }

    var altCount = {};
    state.required.forEach(function(x){ if(x.altGroup) altCount[x.altGroup] = (altCount[x.altGroup]||0)+1; });

    ziel.innerHTML = state.required.map(function(x){
      var isRec = x.requirement === 'RECOMMENDED';
      var wort = isRec ? T.requiredLabelRec : T.requiredLabel;
      if(x.altGroup && altCount[x.altGroup] > 1) wort += ' · ' + (T.altOneOf || 'eine Variante genügt');
      if(x.liegtBei) wort += ' · ' + T.liegtBeiLabel;
      var sp = x.sp;

      var geraete = _zeilenGeraete(x);
      var art = (x.product && x.product.type) || '';
      var info = x.message || '';
      var nr = info ? (regelTexte.push({ marke: wort, titel: (sp && sp.title) || x.sku, text: info }) - 1) : null;

      var griff = '<span class="fn-stufe">' + esc(wort)
        + (nr != null ? ' <button type="button" class="fn-stufe-i" data-regel="' + nr + '" data-fenster-auf="fn-regel" aria-label="' + esc(T.warum || 'Warum?') + '">i</button>' : '')
        + '</span>';

      if(!sp || !sp.variant_id){
        return '<div class="fn-pzeile is-aus">'
          + '<span class="fn-haken fn-haken--offen" aria-hidden="true"></span>'
          + '<span class="fn-pzeile-bild"></span>'
          + '<span class="fn-pzeile-txt"><span class="fn-pzeile-n">' + esc(_teilNameFuer(art, (x.product && x.product.name) || T.reqUnbekannt, geraete)) + '</span>'
          + griff + '<small class="fn-pzeile-notiz">' + esc(T.reqUnbestellbar) + '</small></span>'
          + '</div>';
      }
      var an = !!state.reqOn[x.sku];
      var q = x.qty || 1;
      var notiz = sp.preorder
        ? '<small class="fn-pzeile-notiz" style="color:#6B7280">● ' + esc(sp.preorder) + '</small>'
        : (sp.available ? '' : '<small class="fn-pzeile-notiz" style="color:var(--3idee-error)">● ' + esc(T.soldout) + '</small>');
      return '<div class="fn-pzeile' + (sp.available ? '' : ' is-aus') + '">'
        + '<button type="button" class="fn-haken' + (an ? ' is-on' : '') + '" data-sku="' + esc(x.sku) + '" aria-pressed="' + (an ? 'true' : 'false') + '" aria-label="' + esc(sp.title) + '"></button>'
        + (sp.image ? '<span class="fn-pzeile-bild"><img src="' + esc(sp.image) + '" alt=""></span>' : '<span class="fn-pzeile-bild"></span>')
        + '<span class="fn-pzeile-txt"><span class="fn-pzeile-n">' + (q > 1 ? q + '× ' : '') + esc(_teilNameFuer(art, sp.title, geraete)) + '</span>' + griff + notiz + '</span>'
        + '<span class="fn-pzeile-p">' + (sp.price != null ? _price(sp.price * q) : '') + '</span>'
        + '</div>';
    }).join('');

    ziel.querySelectorAll('.fn-haken[data-sku]').forEach(function(b){
      b.addEventListener('click', function(){
        var sku = b.getAttribute('data-sku');
        var an = !state.reqOn[sku];
        state.reqOn[sku] = an;

        if(an) delete state.reqAus[sku]; else state.reqAus[sku] = true;
        if(an){
          var gewaehlt = state.required.filter(function(x){ return x.sku === sku; })[0];
          if(gewaehlt && gewaehlt.altGroup){
            state.required.forEach(function(x){
              if(x.altGroup === gewaehlt.altGroup && x.sku !== sku){ delete state.reqOn[x.sku]; state.reqAus[x.sku] = true; }
            });
          }
        }
        renderRequired();
        if(root.__redrawPresets) root.__redrawPresets();
        renderSummary();
      });
    });
    ziel.querySelectorAll('[data-regel]').forEach(function(b){ regelFensterBinden(b); });
  }

  function oneWort(){
    var t = (d && d.tOneLabel ? String(d.tOneLabel) : '').trim();
    return t || '3IDEE® ONE';
  }

  function reiterBauen(groups){
    var leiste = $('[data-role="mount-tabs"]');
    if(!leiste) return;
    leiste.innerHTML = '';

    if(groups.length < 2){
      leiste.style.display = 'none';
      groups.forEach(function(gr){ if(gr.box) gr.box.style.display = ''; });

      montageArt(groups.length ? groups[0].art : '');
      var kopf0 = $('[data-role="one-head"]');
      if(kopf0) kopf0.style.display = (groups.length && groups[0].istOne) ? '' : 'none';
      return;
    }
    leiste.style.display = '';

    var aktiv = 0;
    for(var i=0;i<groups.length;i++){ if(groups[i].items.length){ aktiv = i; break; } }
    var gewaehlt = state.selPreset != null ? state.presets[state.selPreset] : null;
    if(gewaehlt){
      for(var j=0;j<groups.length;j++){
        if(groups[j].items.some(function(it){ return it === gewaehlt || it.x === gewaehlt; })){ aktiv = j; break; }
      }
    }

    function zeige(n){
      groups.forEach(function(gr, i){
        if(gr.box) gr.box.style.display = (i === n ? '' : 'none');
      });
      leiste.querySelectorAll('button').forEach(function(b, i){
        b.setAttribute('aria-selected', i === n ? 'true' : 'false');
      });
      montageArt(groups[n] && groups[n].art);

      var kopf = $('[data-role="one-head"]');
      if(kopf) kopf.style.display = (groups[n] && groups[n].istOne) ? '' : 'none';
    }

    groups.forEach(function(gr, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');

      b.innerHTML = esc(gr.label || '')
        + '<span class="fn-tab-zahl">' + gr.items.length + '</span>';
      if(!gr.items.length) b.className = 'is-empty';
      b.addEventListener('click', function(){ zeige(i); });
      leiste.appendChild(b);

      var head = gr.box && gr.box.querySelector('.fn-mount-head');
      if(head) head.style.display = 'none';
    });

    zeige(aktiv);
  }

  function montageArt(art){
    state.mountKey = art || '';
    var tisch = $('[data-role="tischangabe"]');
    if(tisch) tisch.hidden = (art === 'wall');
    renderOptional();
  }

  function renderPresets(){
    var grid=$('[data-role="presets"]'), moreWrap=$('[data-role="more"]');
    if(!grid) return;

    if(_allesOffen()){
      showHalterungFallback(false);

      satzBauen();
      return;
    }
    var oneSec=$('[data-role="one-section"]');
    var oneHead=$('[data-role="one-head"]');
    var mountWrap=$('[data-role="mount-groups"]');
    var emptyBox=$('[data-role="halterung-empty"]');

    if(!state.presets.length){
      var leiste0 = $('[data-role="mount-tabs"]');
      if(leiste0){ leiste0.style.display='none'; leiste0.innerHTML=''; }
      if(oneSec) oneSec.style.display='none';
      if(oneHead) oneHead.style.display='none';
      if(mountWrap) mountWrap.innerHTML='';
      if(emptyBox) emptyBox.style.display='';
      root.__redrawPresets = null;
      return;
    }
    if(emptyBox) emptyBox.style.display='none';

    var oneItems=[], mountItems=[];
    state.presets.forEach(function(x, idx){ (x.kind==='mount' ? mountItems : oneItems).push({ x:x, idx:idx }); });

    (function(){
      var rang = { spar:0, zweiter:1 };
      var r = function(it){ return rang.hasOwnProperty(it.x.empfehlung) ? rang[it.x.empfehlung] : 2; };
      mountItems = mountItems.map(function(it, i){ return { it:it, i:i }; })
        .sort(function(a, b){ return r(a.it) - r(b.it) || a.i - b.i; })
        .map(function(o){ return o.it; });
    })();

    if(oneSec)  oneSec.style.display  = oneItems.length ? '' : 'none';
    if(oneHead) oneHead.style.display = oneItems.length ? '' : 'none';

    function card(x, idx){
      var s=x.sp, sel=(state.selPreset===idx), meta=x.meta||null;

      var badgeTxt = meta ? _metaPlain(meta.badge) : '';
      var badge = badgeTxt ? '<span class="fn-badge">'+esc(badgeTxt)+'</span>' : '';

      if(meta && meta.neu) badge = '<span class="neu-etikett">'+esc(T.neu)+'</span>' + badge;
      var badges = badge ? '<span class="fn-badges">'+badge+'</span>' : '';

      var media='<span class="fn-preset-media">'
        + '<span class="fn-haken' + (sel ? ' is-on' : '') + '" aria-hidden="true"></span>' + badges
        + (s.image ? '<img src="'+esc(s.image)+'" alt="'+esc(s.title)+'" loading="lazy">' : '')

        + (!s.available ? '<span class="fn-sold">'+esc(T.soldout)+'</span>' : '') + '</span>';

      var teaserUnits = (x.kind !== 'mount') ? _bundleUnitsPotential(x.armCount) : 0;
      var saveCents = (BUNDLE_AMOUNT>0 && teaserUnits>0) ? Math.round(teaserUnits*BUNDLE_AMOUNT*100) : 0;

      saveCents = 0;
      var erfuellt = !!(sel && _bundleUnits(x.armCount) >= teaserUnits);
      var priceBlock = '';

      var kr = 0, krAktion = false, kRab = meta && meta.rabatt;
      if(kRab && Number(kRab.wert)>0 && s.price!=null){
        kr = kRab.art==='prozent' ? Math.round(s.price*Number(kRab.wert)/100) : Math.round(Number(kRab.wert)*100);
        krAktion = !!kRab.aktion;
      }
      if(s.price!=null && kr>0 && kr<s.price){
        priceBlock = '<div class="fn-preset-price"><s class="fn-price-was">'+_price(s.price)+'</s> '
          + '<span class="vorteil-preis'+(krAktion?' vorteil-preis--aktion':'')+'">'+_price(s.price-kr)+'</span></div>';
      } else if(s.price!=null){
        priceBlock = (saveCents>0 && saveCents<s.price)
          ? '<div class="fn-preset-price"><s class="fn-price-was">'+_price(s.price)+'</s><span class="fn-price-now">'+_price(s.price-saveCents)+'</span>'
            + _vorteilEtikett(teaserUnits, erfuellt) + '</div>'
          : '<div class="fn-preset-price">'+_price(s.price)+'</div>';
      }
      var handle = (s.url || '').split('/products/')[1] || '';
      handle = handle.split('?')[0].split('#')[0];
      return '<article class="fn-preset'+(sel?' is-sel':'')+'" data-idx="'+idx+'"'
        + ' data-mini-handle="'+esc(handle)+'"'
        + ' data-mini-vorteil="'+saveCents+'" data-mini-einheiten="'+teaserUnits+'"'
        + (s.available ? ' role="button" tabindex="0" aria-pressed="'+(sel?'true':'false')+'"' : ' aria-disabled="true"')
        + '>' + media
        + '<div class="fn-preset-body">'

        + '<a class="fn-preset-title" href="'+esc(s.url)+'" data-mini-auf>'
        + ((meta && meta.karte_name)
            ? (meta.karte_zeile ? '<span class="fn-preset-serie">'+esc(meta.karte_zeile)+'</span>' : '')
              + '<span class="fn-preset-name">'+esc(meta.karte_name)+'</span>'
            : esc(s.title))
        + '</a>'
        + ((meta && meta.karte_eck) ? meta.karte_eck : '')
        + priceBlock

        + (x.traglast==='knapp'?'<div class="fn-preset-traglast">'+esc(T.traglastKnapp)+'</div>':'')
        + '</div></article>';
    }

    function drawGroup(desc){
      var g=desc.grid, mw=desc.more, items=desc.items;
      if(!g) return;
      var mobile = window.matchMedia('(max-width: 760px)').matches;

      var shown = items.length;
      g.innerHTML = items.slice(0, shown).map(function(it){ return card(it.x, it.idx); }).join('');

      if(!g.__gebunden){
      g.__gebunden = true;
      g.addEventListener('click', function(e){
        var karte = e.target.closest && e.target.closest('.fn-preset');
        if(!karte) return;
        if(e.target.closest('[data-mini-auf]')){
          e.preventDefault();

          miniPdpOeffnen(karte.getAttribute('data-mini-handle'),
                         Number(karte.getAttribute('data-mini-vorteil')) || 0,
                         Number(karte.getAttribute('data-mini-einheiten')) || 0);
          return;
        }
        if(karte.getAttribute('aria-disabled') === 'true') return;
        selectPreset(+karte.getAttribute('data-idx'));
      });
      g.addEventListener('keydown', function(e){
        if(e.key !== 'Enter' && e.key !== ' ') return;
        var karte = e.target.closest && e.target.closest('.fn-preset[role="button"]');
        if(!karte) return;
        e.preventDefault();
        selectPreset(+karte.getAttribute('data-idx'));
      });
      }
      if(mw){ mw.style.display='none'; mw.innerHTML=''; }
    }

    var groups = [];
    if(oneItems.length) groups.push({ items:oneItems, grid:grid, more:moreWrap,
                                      label:oneWort(), box:oneSec, art:'desk', istOne:true });
    if(mountWrap){
      mountWrap.innerHTML='';
      mountWrap.classList.toggle('is-solo', !oneItems.length);
      var buckets = [

        { label:T.mountDesk,  art:'desk', test:function(t){ return t==='tischhalterung'; } },
        { label:T.mountWall,  art:'wall', test:function(t){ return t.indexOf('wand')===0; } },
        { label:T.mountOther, art:'',     test:function(){ return true; } }
      ];
      var bucketOf = function(t){ for(var b=0;b<buckets.length;b++){ if(buckets[b].test(t||'')) return b; } return buckets.length-1; };
      buckets.forEach(function(bk, bi){
        var items = mountItems.filter(function(it){ return bucketOf(it.x.mountType)===bi; });

        if(!items.length && bi === buckets.length - 1) return;
        var sec=document.createElement('div'); sec.className='fn-mount-section';
        var head=document.createElement('div'); head.className='fn-mount-head'; head.textContent=bk.label;
        var g=document.createElement('div'); g.className='fn-halt-grid';
        var mw=document.createElement('div'); mw.className='fn-more';
        sec.appendChild(head); sec.appendChild(g); sec.appendChild(mw);
        if(!items.length){
          var leer=document.createElement('p'); leer.className='fn-tab-leer';
          leer.textContent=T.tabLeer; sec.appendChild(leer);
        }
        mountWrap.appendChild(sec);
        groups.push({ items:items, grid:g, more:mw, label:bk.label, box:sec, art:bk.art });
      });
    }

    reiterBauen(groups);
    satzBauen();
    bloeckeSetzen();

    root.__redrawPresets = function(){ groups.forEach(drawGroup); };
    root.__redrawPresets();

    if(!root.__presetsMqBound){
      root.__presetsMqBound = true;
      var _mq = window.matchMedia('(max-width: 760px)');
      var _mqHandler = function(){ if(root.__redrawPresets) root.__redrawPresets(); };
      if(_mq.addEventListener) _mq.addEventListener('change', _mqHandler);
      else if(_mq.addListener) _mq.addListener(_mqHandler);
    }
  }

  function renderOptional(){
    var sec = $('[data-role="optional"]'), ziel = $('[data-role="optional-body"]');
    if(!sec || !ziel) return;

    if(_allesOffen()){ sec.style.display = 'none'; ziel.innerHTML = ''; return; }
    if(!state.optional.length){ sec.style.display = 'none'; ziel.innerHTML = ''; return; }
    sec.style.display = '';

    ziel.innerHTML = state.optional.map(function(x, i){
      var sp = x.sp;
      var an = !!(sp.variant_id && state.optOn[sp.variant_id] !== undefined);
      var kaufbar = !!(sp.available && sp.variant_id);
      var info = x.message || sp.description || '';
      var nr = info ? (regelTexte.push({ marke: T.optionalLabel, titel: sp.title, text: info }) - 1) : null;
      return '<div class="fn-pzeile' + (kaufbar ? '' : ' is-aus') + '">'
        + (kaufbar
            ? '<button type="button" class="fn-haken' + (an ? ' is-on' : '') + '" data-oi="' + i + '" aria-pressed="' + (an ? 'true' : 'false') + '" aria-label="' + esc(sp.title) + '"></button>'
            : '<span class="fn-haken fn-haken--offen" aria-hidden="true"></span>')
        + (sp.image ? '<span class="fn-pzeile-bild"><img src="' + esc(sp.image) + '" alt=""></span>' : '<span class="fn-pzeile-bild"></span>')

        + '<span class="fn-pzeile-txt"><span class="fn-pzeile-n">' + esc(sp.title)
        + (nr != null ? ' <button type="button" class="fn-stufe-i" data-regel="' + nr + '" data-fenster-auf="fn-regel" aria-label="' + esc(T.warum || 'Warum?') + '">i</button>' : '')
        + '</span>'
        + (kaufbar ? '' : '<small class="fn-pzeile-notiz">' + esc(T.soldout) + '</small>')
        + '</span>'
        + '<span class="fn-pzeile-p">' + (sp.price != null ? _price(sp.price) : '') + '</span>'
        + '</div>';
    }).join('');

    ziel.querySelectorAll('.fn-haken[data-oi]').forEach(function(b){
      b.addEventListener('click', function(){
        var oi = +b.getAttribute('data-oi'), sp = state.optional[oi].sp;
        if(state.optOn[sp.variant_id] === undefined) state.optOn[sp.variant_id] = oi;
        else delete state.optOn[sp.variant_id];
        renderOptional();
        renderSummary();
      });
    });
    ziel.querySelectorAll('[data-regel]').forEach(function(b){ regelFensterBinden(b); });
  }

  var CTA_WORT_URSPRUNG = null;

  var _mleisteBoxSichtbar = false, _mleisteBeobachtet = false;
  function mleiste(){
    var leiste = $('[data-role="mleiste"]'); if(!leiste) return;
    var box = $('[data-role="summary"]'), summe = $('.fn-bb-total'), cta = $('[data-role="cta-add"]');
    if(!_mleisteBeobachtet && box && window.IntersectionObserver){
      _mleisteBeobachtet = true;
      new IntersectionObserver(function(e){ _mleisteBoxSichtbar = e[0].isIntersecting; mleiste(); }).observe(box);
      var k = $('[data-role="mleiste-knopf"]');
      if(k) k.addEventListener('click', function(){
        var c = $('[data-role="cta-add"]');
        if(c && !c.disabled && c.style.display !== 'none') c.click();
        else if(box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    var an = state.selPreset != null && summe && summe.style.display !== 'none' && cta && cta.style.display !== 'none';
    leiste.hidden = !an || _mleisteBoxSichtbar;
    var knopf = $('[data-role="mleiste-knopf"]'), wort = cta && cta.querySelector('.add-to-cart-text__content');
    if(knopf && wort) knopf.textContent = wort.textContent;
  }

  function ctaWort(wort){
    $$('[data-role="cta-add"]').forEach(function(btn){
      var ziel = btn.querySelector('.add-to-cart-text__content');
      if(!ziel) return;
      if(CTA_WORT_URSPRUNG == null) CTA_WORT_URSPRUNG = ziel.textContent;
      ziel.textContent = wort || CTA_WORT_URSPRUNG;
    });
  }

  function logistikZeigen(items, allAvail){
    var zeile = $('[data-fn-log]');
    var lz = $('[data-fn-lgz]');

    var block = $('[data-fn-usp]');

    var da = !!(items && items.length);
    if(block) block.style.display = da ? '' : 'none';

    var tlz = $('[data-fn-traglast]');
    if(tlz){
      var tp = (da && state.selPreset != null) ? state.presets[state.selPreset] : null;
      var th = (tp && tp.traglast === 'knapp' && tp.traglastHinweis) || '';
      tlz.textContent = th;
      tlz.style.display = th ? '' : 'none';
    }
    if(!zeile || !lz) return;
    if(!da){ zeile.style.display = 'none'; return; }

    var pm = state.presets[state.selPreset] && state.presets[state.selPreset].meta;
    var stufe, text;
    if(!allAvail){ stufe = 'aus'; text = T.nichtVerfuegbar; }
    else if(items.some(function(x){ return x.preorder; })){
      stufe = 'vor';
      text = T.vorbestellbar + ((pm && pm.liefertermin) ? ' – ' + T.lieferbarAb.replace('%s', pm.liefertermin) : '');
    }
    else if(items.some(function(x){ return x.mto; })){ stufe = 'mto'; text = T.gefertigt; }
    else if(pm && pm.lieferbar_ab){ stufe = 'ab'; text = T.lieferbarAb.replace('%s', pm.lieferbar_ab); }
    else { stufe = 'lager'; text = T.inStock; }
    lz.className = 'lgz lgz--' + stufe + ' usp__lgz';
    var t = lz.querySelector('.lgz__text'); if(t) t.textContent = text;
    zeile.style.display = '';
  }

  function setSummaryEmpty(){
    logistikZeigen([], true);
    var box0=$('[data-role="summary"]'); if(box0) box0.classList.add('fn-buybox--leer');
    var l=$('[data-role="summary-lines"]');
    if(l) l.innerHTML='<div class="fn-sline-empty">'+esc(T.nothing)+'</div>';
    var summe0=$('.fn-bb-total'); if(summe0) summe0.style.display = 'none';
    setText('[data-role="total"]','–'); setText('[data-role="mobile-total"]','–'); setText('[data-role="drawer-total"]','–');
    ctaWort(null);
    disable('[data-role="cta-add"]', true); disable('[data-role="drawer-add"]', true);
    var del=$('[data-role="delivery"]'); if(del) del.style.display='none';
    var bw0=$('[data-role="beste-wahl"]'); if(bw0) bw0.hidden = true;
    $$('[data-role="total-strike"]').forEach(function(e){ e.style.display='none'; });

    $$('[data-role="sparst"]').forEach(function(e){ e.innerHTML=''; });
    document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: 0 } }));
    hidePostAdd();

    renderVesaCta();
    if(_allesOffen()) _sonderloesungZeigen();
    mleiste();
  }

  function _allesOffen(){
    var offen = sonderloesungMonitore().length;
    if(!offen) return false;
    var alle = filledMonitors().length;
    return alle > 0 && offen === alle;
  }

  function _sonderloesungZeigen(){
    logistikZeigen([], true);

    var del = $('[data-role="delivery"]');
    if(del) del.style.display = 'none';
    var zeilen = $('[data-role="summary-lines"]');
    if(zeilen) zeilen.innerHTML = '';
    $$('[data-role="cta-add"]').forEach(function(b){ b.style.display = 'none'; });
    $$('[data-role="drawer-add"]').forEach(function(b){ b.style.display = 'none'; });

    var summe = $('.fn-bb-total'); if(summe) summe.style.display = 'none';
    $$('[data-role="cta-halterung"]').forEach(function(b){ b.style.display = 'none'; });
    $$('[data-role="cta-required"]').forEach(function(b){ b.style.display = 'none'; });

    var box = $('[data-role="summary"]'); if(box) box.classList.add('is-sonder');
  }

  function _kaufzoneZurueck(){
    $$('[data-role="cta-add"]').forEach(function(b){ b.style.display = ''; });
    $$('[data-role="drawer-add"]').forEach(function(b){ b.style.display = ''; });

    var box = $('[data-role="summary"]');
    var leer = box && box.classList.contains('fn-buybox--leer');
    var summe = $('.fn-bb-total'); if(summe && !leer) summe.style.display = '';
    if(box) box.classList.remove('is-sonder');
  }

  function renderVesaCta(){

    var noVesa = sonderloesungMonitore().length > 0;
    var waCta = $('[data-role="cta-wa"]');
    if(waCta){
      waCta.style.display = noVesa ? '' : 'none';
      if(noVesa) waCta.setAttribute('href', _waLinkWithSetup());
    }
    var addBtnEl = $('[data-role="cta-add"]');
    if(addBtnEl) addBtnEl.classList.toggle('fn-bb-cta--secondary', noVesa);

    if(_allesOffen()){
      disable('[data-role="cta-add"]', true);
      disable('[data-role="drawer-add"]', true);
    } else {
      _kaufzoneZurueck();
    }
  }
  function renderSummary(){
    renderVesaCta();

    var uspP = state.selPreset!=null ? state.presets[state.selPreset] : null;

    document.dispatchEvent(new CustomEvent('3idee:usp-gruppe', { detail: { gruppe: uspP ? (uspP.kind==='one' ? 'one' : 'mount') : (summaryItems().length ? 'adapter' : null) } }));
    var items=summaryItems();
    var offene=sonderloesungMonitore();

    if(!items.length && !offene.length){ setSummaryEmpty(); return; }
    var box=$('[data-role="summary"]'); if(box) box.classList.remove('fn-buybox--leer');
    var sub=items.reduce(function(a,x){return a+(x.price||0)*(x.qty||1);},0);
    var disc=bundleDiscountCents();

    var rabatte=[], rab=items.reduce(function(a,x){
      var r=x.rabatt; if(!r || !(Number(r.wert)>0)) return a;
      var c = r.art==='prozent' ? Math.round((x.price||0)*Number(r.wert)/100) : Math.round(Number(r.wert)*100);
      rabatte.push(r);
      return a + c*(x.qty||1);
    },0);
    var total=Math.max(0, sub-disc-rab);

    function kzeile(name, preis, notiz){
      return '<div class="fn-kzeile"><span class="fn-kzeile-txt">'
        + '<span class="fn-kzeile-n">' + esc(name) + '</span>'
        + (notiz ? '<small class="fn-kzeile-notiz">' + notiz + '</small>' : '')
        + '</span><span class="fn-kzeile-p">' + (preis || '') + '</span></div>';
    }

    var etk = function(t, a){ return '<span class="vorteil-etikett'+(a?' vorteil-etikett--aktion':'')+'">'+esc(t)+'</span>'; };
    var linesHTML = items.map(function(x){
      var q = x.qty || 1, voll = (x.price || 0) * q, r = x.rabatt, ab = 0;
      if(r && Number(r.wert)>0){
        ab = (r.art==='prozent' ? Math.round((x.price||0)*Number(r.wert)/100) : Math.round(Number(r.wert)*100)) * q;
      }
      var preis = ab>0
        ? '<s class="fn-price-was">'+_price(voll)+'</s> '+_price(voll-ab)
        : _price(voll);
      var notiz = x.available ? '' : '<span style="color:var(--3idee-error)">● ' + esc(T.soldout) + '</span>';
      if(ab>0){
        var rText = (r.art==='prozent' ? '−'+Math.round(Number(r.wert))+' %' : '−'+_price(Math.round(Number(r.wert)*100))) + (!r.aktion && r.titel ? ' '+r.titel : '');
        var rUhr = r.ende ? '<span class="rabatt-countdown rabatt-countdown--anhang" role="timer" data-form="anhang" data-rabatt-ende-iso="'+esc(r.ende)+'"></span>' : '';
        notiz = '<span class="rabatt-uhr">' + etk(rText, r.aktion) + rUhr + '</span>' + (notiz ? ' '+notiz : '');
      }
      return kzeile((q > 1 ? q + '× ' : '') + _teilNameFuer(x.art, x.title, x.geraete), preis, notiz);
    }).join('');
    if(disc>0){
      linesHTML += '<div class="fn-kzeile fn-kzeile--bundle"><span class="fn-kzeile-txt">'
        + '<span class="vorteil-etikett vorteil-etikett--kontur">'+esc(BUNDLE_TITEL)+'</span></span>'
        + '<span class="fn-kzeile-p">\u2212'+_price(disc)+'</span></div>';
    }

    offene.forEach(function(m){
      linesHTML += kzeile(m.name, '', esc(T.openLabel || 'Offen'));
    });

    var summe=$('.fn-bb-total'); if(summe) summe.style.display = '';

    var stueck = items.reduce(function(n, x){ return n + (x.qty || 1); }, 0);
    ctaWort(stueck > 1 ? T.korbWort.replace('%d', stueck) : null);
    var l=$('[data-role="summary-lines"]'); if(l) l.innerHTML=linesHTML;
    var dl=$('[data-role="drawer-lines"]'); if(dl) dl.innerHTML=linesHTML;

    $$('[data-role="total-strike"]').forEach(function(e){ if(disc+rab>0){ e.style.display=''; e.textContent=_price(sub); } else e.style.display='none'; });
    setText('[data-role="total"]', _price(total));

    $$('[data-role="vorteile"]').forEach(function(e){ e.innerHTML = ''; e.hidden = true; });
    $$('[data-role="sparst"]').forEach(function(e){
      e.innerHTML = (disc+rab>0) ? '<span class="vorteil-etikett vorteil-etikett--sparst">'
        + esc(String(T.sparst||'Du sparst %s').replace('%s', _price(disc+rab))) + '</span>' : '';
    });

    document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: total } }));
    setText('[data-role="mobile-total"]', _price(total));
    setText('[data-role="drawer-total"]', _price(total));
    setTimeout(mleiste, 0);

    var hasPreset = state.selPreset!=null;
    var allAvail = items.every(function(x){ return x.available; });
    logistikZeigen(items, allAvail);

    var selP = state.selPreset!=null ? state.presets[state.selPreset] : null;
    var bundlePlateBad = !!(selP && selP.fit==='bundle' && !(selP.requiresSp && selP.requiresSp.variant_id && selP.requiresSp.available));

    var incomplete = !items.length || !allAvail || bundlePlateBad || _allesOffen();
    disable('[data-role="cta-add"]', incomplete);
    disable('[data-role="drawer-add"]', incomplete);

    var missingReq = state.required.some(function(x){
      return x.requirement==='REQUIRED' && !x.liegtBei && x.sp && x.sp.available && x.sp.variant_id && !_reqCovered(x);
    });
    var missingRec = state.required.some(function(x){
      return x.requirement==='RECOMMENDED' && !x.liegtBei && x.sp && x.sp.available && x.sp.variant_id && !_reqCovered(x);
    });
    var del=$('[data-role="delivery"]');

    var bw=$('[data-role="beste-wahl"]');
    if(bw){
      var bwZeigen = !hasPreset && items.length && state.presets.length && !_allesOffen();
      bw.hidden = !bwZeigen;
      if(bwZeigen){
        var bisZu = bundleBisZuCents();
        var mons = filledMonitors(), namen = [];
        mons.forEach(function(m){ if(namen.indexOf(m.name) < 0) namen.push(m.name); });
        bw.innerHTML = '<span class="beste-wahl beste-wahl--akzent lw__beste">' + esc(T.besteWahl) + '</span>'
          + '<span class="lw__text"><span class="lw__titel">' + esc(T.setupKomplett) + '</span>'
          + (namen.length ? '<span class="lw__unter">' + esc(String(T.passendFuer).replace('%s', namen.join(', '))) + '</span>' : '')
          + (bisZu > 0 ? '<span class="vorteil-etikett vorteil-etikett--kontur fn-bw-vorteil">' + esc(String(T.bisZu).replace('{{ betrag }}', _price(bisZu)).replace('{{ titel }}', BUNDLE_TITEL)) + '</span>' : '')
          + '</span><span class="fn-bw-pfeil" aria-hidden="true"></span>';

        bw.onclick = function(){
          var block = $('[data-role="one-wrap"]');
          var karte = block ? [].slice.call(block.querySelectorAll('.fn-preset[role="button"]')).filter(function(k){ return k.offsetParent !== null; })[0] : null;
          if(karte) karte.click();
          if(!block) return;
          hinlenken(block);

          setTimeout(function(){
            block.classList.remove('fn-aufmerk'); void block.offsetWidth;
            block.classList.add('fn-aufmerk');
            setTimeout(function(){ block.classList.remove('fn-aufmerk'); }, 2200);
          }, 450);
        };
      }
    }
    var reqAus = hasPreset && state.required.some(function(x){
      return x.requirement==='REQUIRED' && !x.liegtBei && x.sp && x.sp.variant_id && !x.sp.available && !_reqCovered(x);
    });
    if(del){

      if(_allesOffen()){

        _sonderloesungZeigen();
      } else if(reqAus && allAvail){
        del.style.display=''; del.className='fn-delivery fn-delivery--warn';
        del.innerHTML='<strong>'+esc(T.nichtAufLager)+'</strong>' + (T.fehltTrotzdem ? '<small>'+esc(T.fehltTrotzdem)+'</small>' : '');
      } else if(hasPreset && allAvail && missingReq){
        del.style.display=''; del.className='fn-delivery fn-delivery--warn';
        del.innerHTML='<strong>'+esc(T.fehltPflicht || '! Erforderliches Produkt fehlt noch')+'</strong><small>'+esc(T.fehltHinweis || 'Auswählen, um dein Setup zu vervollständigen')+'</small>';
      } else if(hasPreset && allAvail && missingRec){
        del.style.display=''; del.className='fn-delivery fn-delivery--rec';
        del.innerHTML='<strong>'+esc(T.fehltEmpfohlen || '! Empfohlenes Produkt fehlt noch')+'</strong><small>'+esc(T.inStock)+' · '+esc(T.fehltHinweis || 'Auswählen, um dein Setup zu vervollständigen')+'</small>';
      } else if(hasPreset && allAvail && sonderloesungMonitore().length){

        var openNames = sonderloesungMonitore().map(function(m){ return m.name; }).join(', ');
        del.style.display=''; del.className='fn-delivery fn-delivery--rec';
        del.innerHTML='<strong>'+esc(T.openSummary.replace('%s%', openNames))+'</strong>'
          + (T.openSummarySub ? '<small>'+esc(T.openSummarySub)+'</small>' : '');
      } else if(hasPreset && allAvail){

        del.style.display='none';
      } else if(hasPreset){
        del.style.display=''; del.className='fn-delivery fn-delivery--warn';
        del.innerHTML='<strong>'+esc(T.nichtAufLager || '! Ein Teil deiner Auswahl ist aktuell nicht auf Lager')+'</strong>';
      } else del.style.display='none';
    }

  }

  function showPostAdd(){ var b=$('[data-role="postadd-restart"]'); if(b) b.style.display=''; }
  function hidePostAdd(){ var b=$('[data-role="postadd-restart"]'); if(b) b.style.display='none'; }

  return {
    _vesaChip: _vesaChip,
    renderSlots: renderSlots,
    showVesaGate: showVesaGate,
    showHalterungFallback: showHalterungFallback,
    satzBauen: satzBauen,
    bloeckeSetzen: bloeckeSetzen,
    renderRequired: renderRequired,
    renderPresets: renderPresets,
    renderOptional: renderOptional,
    renderVesaCta: renderVesaCta,
    renderSummary: renderSummary,
    showPostAdd: showPostAdd,
    hidePostAdd: hidePostAdd,
    reiterBauen: reiterBauen,
    syncVesaUI: syncVesaUI,
    buildVesaBox: buildVesaBox,
    openVesaModal: openVesaModal,
    closeVesaModal: closeVesaModal,
    setSummaryEmpty: setSummaryEmpty,
    updateActiveState: updateActiveState,
    oneWort: oneWort
  };
};

